module.exports = __webpack_public_path__ + "img/gloves.398d85b7.svg";